import { createEnum } from "@redotech/zod-util/zod-enum";
import * as z from "zod";
import { aims360Settings } from "./aims360/crud-settings";
import { apparelMagicSettings } from "./apparel-magic/crud-settings";
import { astroSettings } from "./astro/crud-settings";
import { authorizeNetSettings } from "./authorizenet/crud-settings";
import { blueCherrySettings } from "./blue-cherry/crud-settings";
import { blueYonderSettings } from "./blue-yonder/crud-settings";
import { bubblehouseSettings } from "./bubblehouse/crud-settings";
import { cin7CoreSettings } from "./cin7-core/crud-settings";
import { cin7OmniSettings } from "./cin7-omni/crud-settings";
import { cloudxSettings } from "./cloudx/crud-settings";
import { controlPortSettings } from "./controlport/crud-settings";
import { creditsyardSettings } from "./creditsyard/crud-settings";
import { customReturnSettings } from "./custom-return/crud-settings";
import { IntegrationSettings } from "./define-settings";
import { deposcoSettings } from "./deposco/crud-settings";
import { dxFreightSettings } from "./dx-freight/crud-settings";
import { ecwidSettings } from "./ecwid/crud-settings";
import { extensivSettings } from "./extensiv/crud-settings";
import { finaleSettings } from "./finale/crud-settings";
import { flexportSettings } from "./flexport/crud-settings";
import { globaleSettings } from "./globale/crud-settings";
import { growaveSettings } from "./growave/crud-settings";
import { idfShippingSettings } from "./idf-shipping/crud-settings";
import { indigo8Settings } from "./indigo8/crud-settings";
import { katanaSettings } from "./katana/crud-settings";
import { landmarkGlobalSettings } from "./landmark-global/crud-settings";
import { linxSettings } from "./linx/crud-settings";
import { loopSettings } from "./loop/crud-settings";
import { loopzSettings } from "./loopz/crud-settings";
import { luminousSettings } from "./luminous/crud-settings";
import { masonhubSettings } from "./masonhub/crud-settings";
import { mintsoftSettings } from "./mintsoft/crud-settings";
import { odooSettings } from "./odoo/crud-settings";
import { okendoMarketingSettings } from "./okendo-marketing/crud-settings";
import { okendoSettings } from "./okendo/crud-settings";
import { parentEasypostSettings } from "./parent-easypost/crud-settings";
import { purpleDotSettings } from "./purple-dot/crud-settings";
import { refundidSettings } from "./refundid/crud-settings";
import { returnlogicSettings } from "./returnlogic/crud-settings";
import { rivoSettings } from "./rivo/crud-settings";
import { sekoSettings } from "./seko/crud-settings";
import { shipedgeSettings } from "./shipedge/crud-settings";
import { shipheroSettings } from "./shiphero/crud-settings";
import { shipmonkSettings } from "./shipmonk/crud-settings";
import { shipStationSettings } from "./shipstation/crud-settings";
import { smartPackSettings } from "./smartpack/crud-settings";
import { stayAiSettings } from "./stay-ai/crud-settings";
import { stripeSettings } from "./stripe/crud-settings";
import { teamworkCommerceSettings } from "./teamwork-commerce/crud-settings";
import { wayfairSettings } from "./wayfair/crud-settings";
import { wooCommerceSettings } from "./woocommerce/crud-settings";

export enum CRUDIntegration {
  Aims360 = "Aims360",
  ApparelMagic = "ApparelMagic",
  Astro = "Astro",
  AuthorizeNet = "AuthorizeNet",
  BlueCherry = "BlueCherry",
  BlueYonder = "BlueYonder",
  Bubblehouse = "Bubblehouse",
  Cin7Core = "Cin7Core",
  Cin7Omni = "Cin7Omni",
  CloudX = "CloudX",
  ControlPort = "ControlPort",
  CreditsYard = "CreditsYard",
  CustomReturn = "CustomReturn",
  Deposco = "Deposco",
  DxFreightCarrierAccount = "DxFreightCarrierAccount",
  Ecwid = "Ecwid",
  Extensiv = "Extensiv",
  Finale = "Finale",
  Flexport = "Flexport",
  GlobalE = "GlobalE",
  Growave = "Growave",
  IDFShipping = "IDFShipping",
  Indigo8 = "Indigo8",
  Katana = "Katana",
  LandmarkGlobal = "LandmarkGlobal",
  Linx = "Linx",
  Loop = "Loop",
  Loopz = "Loopz",
  Luminous = "Luminous",
  Masonhub = "Masonhub",
  Mintsoft = "Mintsoft",
  Odoo = "Odoo",
  Okendo = "Okendo",
  OkendoMarketing = "OkendoMarketing",
  ParentEasypost = "ParentEasypost",
  PurpleDot = "PurpleDot",
  Refundid = "Refundid",
  ReturnLogic = "ReturnLogic",
  Rivo = "Rivo",
  Seko = "Seko",
  Shipedge = "Shipedge",
  ShipHero = "ShipHero",
  ShipMonk = "ShipMonk",
  ShipStation = "ShipStation",
  SmartPack = "SmartPack",
  StayAi = "StayAi",
  Stripe = "Stripe",
  TeamworkCommerce = "TeamworkCommerce",
  Wayfair = "Wayfair",
  WooCommerce = "WooCommerce",
}

export const CRUD_INTEGRATION_SETTINGS = {
  [CRUDIntegration.Aims360]: aims360Settings,
  [CRUDIntegration.ApparelMagic]: apparelMagicSettings,
  [CRUDIntegration.Astro]: astroSettings,
  [CRUDIntegration.AuthorizeNet]: authorizeNetSettings,
  [CRUDIntegration.BlueCherry]: blueCherrySettings,
  [CRUDIntegration.BlueYonder]: blueYonderSettings,
  [CRUDIntegration.Bubblehouse]: bubblehouseSettings,
  [CRUDIntegration.Cin7Core]: cin7CoreSettings,
  [CRUDIntegration.Cin7Omni]: cin7OmniSettings,
  [CRUDIntegration.CloudX]: cloudxSettings,
  [CRUDIntegration.ControlPort]: controlPortSettings,
  [CRUDIntegration.CreditsYard]: creditsyardSettings,
  [CRUDIntegration.CustomReturn]: customReturnSettings,
  [CRUDIntegration.Deposco]: deposcoSettings,
  [CRUDIntegration.DxFreightCarrierAccount]: dxFreightSettings,
  [CRUDIntegration.Ecwid]: ecwidSettings,
  [CRUDIntegration.Extensiv]: extensivSettings,
  [CRUDIntegration.Finale]: finaleSettings,
  [CRUDIntegration.Flexport]: flexportSettings,
  [CRUDIntegration.GlobalE]: globaleSettings,
  [CRUDIntegration.Growave]: growaveSettings,
  [CRUDIntegration.IDFShipping]: idfShippingSettings,
  [CRUDIntegration.Indigo8]: indigo8Settings,
  [CRUDIntegration.Katana]: katanaSettings,
  [CRUDIntegration.LandmarkGlobal]: landmarkGlobalSettings,
  [CRUDIntegration.Linx]: linxSettings,
  [CRUDIntegration.Loop]: loopSettings,
  [CRUDIntegration.Loopz]: loopzSettings,
  [CRUDIntegration.Luminous]: luminousSettings,
  [CRUDIntegration.Masonhub]: masonhubSettings,
  [CRUDIntegration.Mintsoft]: mintsoftSettings,
  [CRUDIntegration.Odoo]: odooSettings,
  [CRUDIntegration.Okendo]: okendoSettings,
  [CRUDIntegration.OkendoMarketing]: okendoMarketingSettings,
  [CRUDIntegration.ParentEasypost]: parentEasypostSettings,
  [CRUDIntegration.PurpleDot]: purpleDotSettings,
  [CRUDIntegration.Refundid]: refundidSettings,
  [CRUDIntegration.ReturnLogic]: returnlogicSettings,
  [CRUDIntegration.Rivo]: rivoSettings,
  [CRUDIntegration.Seko]: sekoSettings,
  [CRUDIntegration.Shipedge]: shipedgeSettings,
  [CRUDIntegration.ShipHero]: shipheroSettings,
  [CRUDIntegration.ShipMonk]: shipmonkSettings,
  [CRUDIntegration.ShipStation]: shipStationSettings,
  [CRUDIntegration.SmartPack]: smartPackSettings,
  [CRUDIntegration.StayAi]: stayAiSettings,
  [CRUDIntegration.Stripe]: stripeSettings,
  [CRUDIntegration.TeamworkCommerce]: teamworkCommerceSettings,
  [CRUDIntegration.Wayfair]: wayfairSettings,
  [CRUDIntegration.WooCommerce]: wooCommerceSettings,
} satisfies Record<CRUDIntegration, IntegrationSettings>;

type SettingsOf<P extends CRUDIntegration> =
  (typeof CRUD_INTEGRATION_SETTINGS)[P];

type OutputByKind<Bucket extends "fields" | "connect" | "update" | "read"> = {
  [P in CRUDIntegration]: z.output<SettingsOf<P>[Bucket]>;
};

export type ConnectSettings<K extends CRUDIntegration> =
  OutputByKind<"connect">[K];

export type UpdateSettings<K extends CRUDIntegration> =
  OutputByKind<"update">[K];

export type ReadSettings<K extends CRUDIntegration> = OutputByKind<"read">[K];

export type SaveSettings<K extends CRUDIntegration> = UpdateSettings<K> &
  Required<
    Pick<
      UpdateSettings<K>,
      keyof OutputByKind<"fields">[K] & keyof UpdateSettings<K>
    >
  >;

interface SettingsParsers<K extends CRUDIntegration> {
  connect: { parse(settings: unknown): ConnectSettings<K> };
  update: { parse(settings: unknown): UpdateSettings<K> };
  read: { parse(settings: unknown): ReadSettings<K> };
}

const CRUD_SETTINGS_PARSERS: { [P in CRUDIntegration]: SettingsParsers<P> } =
  CRUD_INTEGRATION_SETTINGS;

function parsersFor<K extends CRUDIntegration>(kind: K): SettingsParsers<K> {
  return CRUD_SETTINGS_PARSERS[kind];
}

export function parseConnectSettings<K extends CRUDIntegration>(
  kind: K,
  settings: unknown,
): ConnectSettings<K> {
  return parsersFor(kind).connect.parse(settings);
}

export function parseUpdateSettings<K extends CRUDIntegration>(
  kind: K,
  settings: unknown,
): UpdateSettings<K> {
  return parsersFor(kind).update.parse(settings);
}

export function parseReadSettings<K extends CRUDIntegration>(
  kind: K,
  settings: unknown,
): ReadSettings<K> {
  return parsersFor(kind).read.parse(settings);
}

export type ConnectIntegrationInput = {
  [P in CRUDIntegration]: { kind: P; settings: ConnectSettings<P> };
}[CRUDIntegration];

export type UpdateIntegrationInput = {
  [P in CRUDIntegration]: { kind: P; settings: UpdateSettings<P> };
}[CRUDIntegration];

export type IntegrationRead = {
  [P in CRUDIntegration]: { kind: P; settings: ReadSettings<P> };
}[CRUDIntegration];

const kindInput = z.object({ kind: createEnum(CRUDIntegration) });

const settingsInput = kindInput.extend({ settings: z.unknown() });

function shapedAs<T>(schema: z.ZodType) {
  return z.custom<T>((value) => schema.safeParse(value).success);
}

export const integrationRead = shapedAs<IntegrationRead>(settingsInput);

export const getIntegration = {
  name: "getIntegration" as const,
  input: kindInput,
  output: z.object({ integration: integrationRead.nullable() }),
};

export const connectIntegration = {
  name: "connectIntegration" as const,
  input: shapedAs<ConnectIntegrationInput>(settingsInput),
  output: z.object({}),
};

export const updateIntegration = {
  name: "updateIntegration" as const,
  input: shapedAs<UpdateIntegrationInput>(settingsInput),
  output: z.object({}),
};

export const disconnectIntegration = {
  name: "disconnectIntegration" as const,
  input: kindInput,
  output: z.object({}),
};
